import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import './OrderPage.css';  // Import the CSS file

const OrderPage = () => {
  const [orders, setOrders] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [newOrder, setNewOrder] = useState({
    customerName: "",
    productName: "",
    orderDate: "",
    status: "",
    totalAmount: "",
    quantity: 1, // Default quantity set to 1
  });
  const [editingOrder, setEditingOrder] = useState(null);

  useEffect(() => {
    // Fetch orders from an API or data source
    const fetchOrders = async () => {
      // Example fetching data (replace with actual API call)
      const response = await fetch("/api/orders");
      const data = await response.json();
      setOrders(data);
    };

    fetchOrders();
  }, []);

  const handleShowModal = (order = null) => {
    if (order) {
      setEditingOrder(order);
      setNewOrder(order);  // Pre-fill the form with order data
    } else {
      setEditingOrder(null);
      setNewOrder({
        customerName: "",
        productName: "",
        orderDate: "",
        status: "",
        totalAmount: "",
        quantity: 1, // Reset quantity to default 1
      });
    }
    setShowModal(true);
  };

  const handleCloseModal = () => setShowModal(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewOrder((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (editingOrder) {
      // Update existing order
      const updatedOrders = orders.map((order) =>
        order.id === editingOrder.id ? newOrder : order
      );
      setOrders(updatedOrders);
    } else {
      // Add new order
      setOrders([...orders, { ...newOrder, id: Date.now() }]);
    }

    handleCloseModal();
  };

  const handleDelete = (orderId) => {
    const updatedOrders = orders.filter((order) => order.id !== orderId);
    setOrders(updatedOrders);
  };

  return (
    <div className="order-page">
      <div className="page-header">
        <h1>Order Management</h1>
        <p>Manage your orders effectively</p>
      </div>

      {/* Order List */}
      <table className="order-table">
        <thead>
          <tr>
            <th>Order ID</th>
            <th>Customer Name</th>
            <th>Product(s)</th>
            <th>Order Date</th>
            <th>Status</th>
            <th>Quantity</th>
            <th>Total Amount</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order) => (
            <tr key={order.id}>
              <td>{order.id}</td>
              <td>{order.customerName}</td>
              <td>{order.productName}</td>
              <td>{new Date(order.orderDate).toLocaleDateString()}</td>
              <td>{order.status}</td>
              <td>{order.quantity}</td>
              <td>{order.totalAmount}</td>
              <td>
                <button onClick={() => handleShowModal(order)}>Edit</button>
                <button onClick={() => handleDelete(order.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Add New Order Button */}
      <button className="mb-4" onClick={() => handleShowModal()}>
        Add New Order
      </button>

      {/* Modal for adding/editing order */}
      <Modal show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>{editingOrder ? "Edit Order" : "Add New Order"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group>
              <Form.Label>Customer Name</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter customer name"
                name="customerName"
                value={newOrder.customerName}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Product(s)</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter product name(s)"
                name="productName"
                value={newOrder.productName}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Order Date</Form.Label>
              <Form.Control
                type="date"
                name="orderDate"
                value={newOrder.orderDate}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Status</Form.Label>
              <Form.Control
                as="select"
                name="status"
                value={newOrder.status}
                onChange={handleInputChange}
              >
                <option value="Pending">Pending</option>
                <option value="Completed">Completed</option>
                <option value="Shipped">Shipped</option>
                <option value="Cancelled">Cancelled</option>
              </Form.Control>
            </Form.Group>

            <Form.Group>
              <Form.Label>Quantity</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter quantity"
                name="quantity"
                value={newOrder.quantity}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Form.Group>
              <Form.Label>Total Amount</Form.Label>
              <Form.Control
                type="number"
                placeholder="Enter total amount"
                name="totalAmount"
                value={newOrder.totalAmount}
                onChange={handleInputChange}
              />
            </Form.Group>

            <Button variant="primary" type="submit">
              {editingOrder ? "Update Order" : "Add Order"}
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default OrderPage;
